module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-test"
  }, [_c('form', {
    staticClass: "form-group",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addNewData($event)
      }
    }
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBeer.boughtBy),
      expression: "newBeer.boughtBy"
    }],
    staticClass: "input is-medium",
    attrs: {
      "type": "text",
      "placeholder": "Inköpt av"
    },
    domProps: {
      "value": (_vm.newBeer.boughtBy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newBeer, "boughtBy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBeer.name),
      expression: "newBeer.name"
    }],
    staticClass: "input is-medium",
    attrs: {
      "type": "text",
      "placeholder": "Namn på öl"
    },
    domProps: {
      "value": (_vm.newBeer.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newBeer, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBeer.brewery),
      expression: "newBeer.brewery"
    }],
    staticClass: "input is-medium",
    attrs: {
      "type": "text",
      "placeholder": "Bryggeri/producent"
    },
    domProps: {
      "value": (_vm.newBeer.brewery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newBeer, "brewery", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBeer.img),
      expression: "newBeer.img"
    }],
    staticClass: "input is-medium",
    attrs: {
      "type": "text",
      "placeholder": "Sökväg på bild från systemet"
    },
    domProps: {
      "value": (_vm.newBeer.img)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newBeer, "img", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help"
  }, [_vm._v("Kopiera den absoluta sövägen till den lilla bilden från listvyn och klistra in här.")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBeer.date),
      expression: "newBeer.date"
    }],
    staticClass: "input is-medium",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.newBeer.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newBeer, "date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-medium is-primary",
    attrs: {
      "type": "submit",
      "value": "Add new beer"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6e0d469a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e0d469a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddNew.vue
// module id = 153
// module chunks = 1